import SubmissionsTab from "./SubmissionsTab";

export default function VisaRequestsTab(props) {
  return <SubmissionsTab {...props} collectionName="visaRequests" label="Employment Visa Requests"
    summaryKeys={["fullName", "positionRole"]}/>;
}
